import React from "react";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import CrmInsights from "../CRMUpdatedVersion/CrmInsights";
import CrmAnalyticsCharts from "./CrmAnalyticsCharts";
import CrmIntegrationsPanel from "../CRMUpdatedVersion/CrmIntegrationsPanel";
import CrmAutomationPanel from "../CRMUpdatedVersion/CrmAutomationPanel";
import CrmPlatformSettings from "../CRMUpdatedVersion/CrmPlatformSettings";
import CrmDuplicatePanel from "../CRMUpdatedVersion/CrmDuplicatePanel";
import CrmReportExport from "../CRMUpdatedVersion/CrmReportExport";
import CrmAttributionPanel from "../CRMUpdatedVersion/CrmAttributionPanel";
import CrmWorkflowRulesPanel from "../CRMUpdatedVersion/CrmWorkflowRulesPanel";
import CrmTerritoryPanel from "../CRMUpdatedVersion/CrmTerritoryPanel";
import CrmCustomFieldsPanel from "../CRMUpdatedVersion/CrmCustomFieldsPanel";
import CrmReportBuilder from "../CRMUpdatedVersion/CrmReportBuilder";
import CrmReportDesigner from "../CRMUpdatedVersion/CrmReportDesigner";
import CrmPartnerPortalPanel from "../CRMUpdatedVersion/CrmPartnerPortalPanel";
import CrmGoogleCalendarPanel from "../CRMUpdatedVersion/CrmGoogleCalendarPanel";
import CrmDocuSignPanel from "../CRMUpdatedVersion/CrmDocuSignPanel";
import CrmPageShell from "../CRMUpdatedVersion/CrmPageShell";
import "../CRMUpdatedVersion/LeadsUpdatedVersion.css";

const AnalyticsSection = ({ title, description, children, fullWidth = false }) => (
  <section className={`crm-analytics-section crm-panel ${fullWidth ? "crm-analytics-section--full" : ""}`}>
    {(title || description) && (
      <div className={`crm-panel__header ${!children ? "border-b-0" : ""}`}>
        {title && <h2>{title}</h2>}
        {description && <p>{description}</p>}
      </div>
    )}
    {children ? <div className="crm-panel__body">{children}</div> : null}
  </section>
);

const CRMAnalytics = () => {
  const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");

  return (
    <CrmPageShell variant="analytics">
      <div className="crm-analytics-grid">
        <AnalyticsSection
          title="CRM Analytics"
          description={`Real conversion, pipeline value, and source performance — ${isLoggedIn?.full_name || "your account"}.`}
          fullWidth
        />

        <AnalyticsSection title="Insights" fullWidth>
          <CrmInsights days={30} />
        </AnalyticsSection>

        <AnalyticsSection title="Charts" fullWidth>
          <CrmAnalyticsCharts days={30} />
        </AnalyticsSection>

        <AnalyticsSection title="Automation">
          <CrmAutomationPanel />
        </AnalyticsSection>

        <AnalyticsSection title="Workflow rules">
          <CrmWorkflowRulesPanel />
        </AnalyticsSection>

        <AnalyticsSection title="Marketing attribution" fullWidth>
          <CrmAttributionPanel days={30} />
        </AnalyticsSection>

        <AnalyticsSection title="Report designer" fullWidth>
          <CrmReportDesigner days={30} />
        </AnalyticsSection>

        <AnalyticsSection title="Report builder" fullWidth>
          <CrmReportBuilder days={30} />
        </AnalyticsSection>

        <AnalyticsSection title="Integrations" fullWidth>
          <CrmGoogleCalendarPanel />
          <div className="mt-4 pt-4 border-t border-[var(--border)]">
            <CrmDocuSignPanel />
          </div>
        </AnalyticsSection>

        <AnalyticsSection title="Report export">
          <CrmReportExport days={30} />
        </AnalyticsSection>

        <AnalyticsSection title="Partner portal">
          <CrmPartnerPortalPanel />
        </AnalyticsSection>

        <div className="crm-analytics-grid crm-analytics-grid--settings">
          <AnalyticsSection title="Platform settings">
            <CrmPlatformSettings />
          </AnalyticsSection>

          <AnalyticsSection title="Custom fields">
            <CrmCustomFieldsPanel />
          </AnalyticsSection>

          <AnalyticsSection title="Territory">
            <CrmTerritoryPanel />
          </AnalyticsSection>

          <AnalyticsSection title="Duplicate detection">
            <CrmDuplicatePanel />
          </AnalyticsSection>

          <AnalyticsSection title="Integrations hub" fullWidth>
            <CrmIntegrationsPanel />
          </AnalyticsSection>
        </div>
      </div>
    </CrmPageShell>
  );
};

export default CRMAnalytics;
